import _ from "lodash";
import {
  appliedAdmObj,
  defaultSorting,
  schoolRatedObj,
  srsLodgedObj,
  studentTableSize
} from "utils/AssetsData";
import { FILTER_LABEL, FILTER_VALUE, SCHOOL_RATED, TABLE_FILTER } from "utils/Constants";

export const getTextForShowTotal = (range1: number, range2: number, total: number): string => {
  return range1 == range2
    ? `Showing ${range1} of ${total} results`
    : `Showing ${range1}-${range2} of ${total} results`;
};

export const createPaginatedTableData = (currentPage: number, dataSource: any[]): any[] => {
  const newData = dataSource.slice(
    (currentPage - 1) * studentTableSize,
    (currentPage - 1) * studentTableSize + studentTableSize
  );
  return newData;
};

export const createFilter = (filterObj: any, student: any, isSubmitted: boolean): boolean => {
  const filterVal = [];
  for (const obj in filterObj) {
    if (obj != "name" && filterObj[obj]) {
      if (obj === FILTER_VALUE.YES) {
        filterVal.push(true);
      } else if (obj === FILTER_VALUE.NO) {
        filterVal.push(false);
      } else if (obj === FILTER_VALUE.RATED) {
        filterVal.push(FILTER_LABEL.RATED);
      } else if (obj === FILTER_VALUE.PARTIAL) {
        filterVal.push(SCHOOL_RATED.PARTIAL);
      } else if (obj === FILTER_VALUE.UNRATED) {
        filterVal.push(SCHOOL_RATED.NOT_RATED);
      } else if (obj === FILTER_VALUE.HASFILES) {
        filterVal.push(true);
      } else if (obj === FILTER_VALUE.NOFILES) {
        filterVal.push(false);
      }
    }
  }

  return filterVal.length > 0 ? filterVal.includes(student[filterObj.name]) && isSubmitted : true;
};

export const getStatusAndStyling = (schoolRated: string) => {
  const schoolRatedObj = {
    label: "",
    cssClass: ""
  };

  if (schoolRated === SCHOOL_RATED.RATED) {
    schoolRatedObj.label = FILTER_LABEL.RATED;
    schoolRatedObj.cssClass = "rated-tag";
  } else if (schoolRated === SCHOOL_RATED.PARTIAL || schoolRated === SCHOOL_RATED.UNSUBMITTED) {
    schoolRatedObj.label = FILTER_LABEL.PARTIAL;
    schoolRatedObj.cssClass = "partial-tag";
  } else if (schoolRated === SCHOOL_RATED.NOT_RATED) {
    schoolRatedObj.label = FILTER_LABEL.UNRATED;
    schoolRatedObj.cssClass = "unrated-tag";
  }

  return schoolRatedObj;
};

export const applySort = (sortObj: any, tableData: any) => {
  if (!sortObj) return _.orderBy(tableData, defaultSorting.field, "asc");
  const { field, dir } = sortObj;
  let sorted = [];

  if (!dir) {
    sorted = _.orderBy(tableData, defaultSorting.field, "asc");
  } else {
    if (field === "schoolRated") {
      sorted = _.orderBy(tableData, "schoolRatedWithStatus", dir);
    } else {
      sorted = _.orderBy(tableData, field, dir);
    }
  }

  return sorted;
};

export const applySearch = (search: string, tableData: any) => {
  return tableData?.filter((entry: any) => {
    const givenName1 = entry.givenName1.toUpperCase();
    const familyName = entry.familyName.toUpperCase();
    const fullName = `${givenName1} ${familyName}`;
    return (
      givenName1.includes(search) ||
      familyName.includes(search) ||
      fullName.includes(search) ||
      entry.studentNumber?.toString()?.includes(search)
    );
  });
};

export const updateFilters = (filters: any, filterList: any, type: string) => {
  return filters.map((filterObj: any) => {
    if (type == filterObj.name) {
      let copiedFilterObj = JSON.parse(JSON.stringify(filterObj));

      if (filterList.length == 0) {
        if (type === TABLE_FILTER.ADMIN_LODGED) {
          copiedFilterObj = appliedAdmObj;
        }
        if (type === TABLE_FILTER.SRS_LODGED) {
          copiedFilterObj = srsLodgedObj;
        }
        if (type === TABLE_FILTER.SCHOOL_RATED) {
          copiedFilterObj = schoolRatedObj;
        }

        return copiedFilterObj;
      } else {
        for (const item in filterObj) {
          if (item !== "name") {
            const hasVal = filterList.includes(item);
            if (hasVal) {
              copiedFilterObj[item] = true;
            } else {
              copiedFilterObj[item] = false;
            }
          }
        }
        return copiedFilterObj;
      }
    }

    return filterObj;
  });
};

export const applyFilters = (origin: any, newFilters: any) => {
  return origin?.filter((student: any) => {
    let isValid = true;

    newFilters.forEach((filterObj: any) => {
      if (filterObj.name == TABLE_FILTER.ADMIN_LODGED) {
        if (!createFilter(filterObj, student, true)) {
          isValid = false;
          return;
        }
      } else if (filterObj.name == TABLE_FILTER.SRS_LODGED) {
        if (!createFilter(filterObj, student, student.appliedAdmission)) {
          isValid = false;
          return;
        }
      } else if (filterObj.name == TABLE_FILTER.SCHOOL_RATED) {
        const usingStudentApi =
          Object.hasOwn(student, "appliedAdmission") && Object.hasOwn(student, "srsLodged");
        const isSubmitted = usingStudentApi ? student.appliedAdmission && student.srsLodged : true;
        if (!createFilter(filterObj, student, isSubmitted)) {
          isValid = false;
          return;
        }
      } else if (filterObj.name == TABLE_FILTER.FILES) {
        if (!createFilter(filterObj, student, true)) {
          isValid = false;
          return;
        }
      }
    });

    if (isValid) {
      return student;
    }
  });
};

export const generateTableData = (tableData: any, search: string, filters: any, sorts: any) => {
  const searched = applySearch(search, tableData);
  const filtered = applyFilters(searched, filters);
  const sorted = applySort(sorts, filtered);
  return sorted;
};

export const hasFilterChange = (prevFilter: any, newFilter: any) => {
  return !_.isEqual(prevFilter, newFilter);
};
